import { useQuery } from '@tanstack/react-query';
import { pagesService } from '../services/pagesService';
import { queryKeys } from '../api/queryClient';
import { useAuth } from './useAuth';
import { useDismissableError } from './useDismissableError';

export function useEngagement(enabled = true) {
  const { applyViewer, user } = useAuth();
  const query = useQuery({
    queryKey: queryKeys.profile(user?.id ?? null),
    queryFn: async () => {
      const data = await pagesService.profile();
      if (data?.viewer) applyViewer(data.viewer);
      return data;
    },
    enabled,
  });

  const { error, setError } = useDismissableError(query.error);

  return {
    engagement: query.data?.engagement ?? null,
    push: query.data?.push ?? null,
    loading: query.isLoading,
    error,
    setError,
  };
}
